import { render, staticRenderFns } from "./UiRoundImage.vue?vue&type=template&id=45c5dba6"
import script from "./UiRoundImage.vue?vue&type=script&lang=js"
export * from "./UiRoundImage.vue?vue&type=script&lang=js"
import style0 from "./UiRoundImage.vue?vue&type=style&index=0&id=45c5dba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports